import { render, staticRenderFns } from "./formAdd_ads.vue?vue&type=template&id=3dcf3f56&scoped=true"
import script from "./formAdd_ads.vue?vue&type=script&lang=js"
export * from "./formAdd_ads.vue?vue&type=script&lang=js"
import style0 from "./formAdd_ads.vue?vue&type=style&index=0&id=3dcf3f56&prod&lang=css&scoped=true"
import style1 from "./formAdd_ads.vue?vue&type=style&index=1&id=3dcf3f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf3f56",
  null
  
)

export default component.exports